import React from 'react'
import { Redirect } from 'react-router'
import HeaderContent from '../components/HeaderContent'
import CircularProgress from '@material-ui/core/CircularProgress'
import Dropzone from 'react-dropzone'
import csvIcon from '../images/csvIcon.svg'
import exploreCsvIcon from '../images/exploreCsvIcon.svg'
import config from '../config'
import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { createLink } from 'apollo-absinthe-upload-link'
import gql from 'graphql-tag'
import { Mutation } from 'react-apollo'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {
  refreshToken
} from '../utils/token'
import {
  getUserInfo
} from '../utils/userInfo'
import {
  getFleetById
} from '../utils/trackable'
import {
  getProduct
} from '../utils/helper'

const client = new ApolloClient({
  link: createLink({
    uri: config.pi_url + '/graphiql'
  }),
  cache: new InMemoryCache()
})

export const UPLOAD_FILE = gql`
  mutation uploadTickets($file: Upload!) {
    uploadTickets(file: $file) 
  }
`

class UploadTicket extends React.Component {
  constructor () {
    super()
    this._isMounted = false
    this.state = {
      loading: true
    }
  }

  componentDidMount () {
    const self = this
    this._isMounted = true
    var product = this.props.match.params.product_id
    var token = localStorage.getItem('token')
    if (this._isMounted) {
      getUserInfo(token)
        .then(response => response.json())
        .then(async function (data) {
          if (data.error && data.error.code === 401) {
            refreshToken(localStorage.getItem('refresh_token')).then(function () {
              var newToken = localStorage.getItem('token')
              getUserInfo(newToken)
                .then(response => response.json())
                .then(async function (data) {
                  var products = data.data.attributes.products.fuel_sensor
                  if (getProduct(products, product).length > 0) {
                    var fleetId = getProduct(products, product)[0].fleets_track_settings[0].fleet_id
                    var fleet = await getFleetById(fleetId)
                    if (fleet) {
                      localStorage.setItem('endpoint', product)
                      let fleetName = fleet.name
                      localStorage.setItem('fleetName', fleetName)
                      self.setState({
                        loading: false
                      })
                    } else document.location.href = '/#/error'
                  } else document.location.href = '/#/error'
                })
                .catch((error) => {
                  console.log('error: ', error)
                })
            })
          } else {
            var products = data.data.attributes.products.fuel_sensor
            if (getProduct(products, product).length > 0) {
              var fleetId = getProduct(products, product)[0].fleets_track_settings[0].fleet_id
              var fleet = await getFleetById(fleetId)
              if (fleet) {
                localStorage.setItem('endpoint', product)
                let fleetName = fleet.name
                localStorage.setItem('fleetName', fleetName)
                self.setState({
                  loading: false
                })
              } else document.location.href = '/#/error'
            } else document.location.href = '/#/error'
          }
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    }
  }

  componentWillUnmount () {
    this._isMounted = false
  }

  showModal () {
    return <Redirect
      to={{
        pathname: `/${localStorage.getItem('endpoint')}/tickets`,
        state: {
          isUploaded: true,
          title: 'Upload csv avec succès'
        }
      }}
    />
  }

  uploadCsv () {
    return (
      <div>
        <Mutation
          mutation={UPLOAD_FILE}
          client={client}
          onCompleted={() =>
            toast.success(this.showModal(), {
              position: toast.POSITION.TOP_CENTER
            })
          }
          onError={() =>
            toast.error('Echec de l\'upload. Merci de vérifier votre fichier!', {
              position: toast.POSITION.TOP_CENTER,
              hideProgressBar: true,
              autoClose: 2000
            })
          }
        >
          {uploadFile => (
            <Dropzone
              accept={'.csv'}
              onDropAccepted={([file]) =>
                uploadFile({
                  variables: {
                    file
                  }
                })
              }
            >
              {({ getRootProps, getInputProps }) => (
                <section>
                  <div {...getRootProps()} style={styles.contentSection}>
                    <img style={styles.iconCsv} src={csvIcon} alt='true' />
                    <p style={styles.label}>
                      Glisser, déposer votre fichier ici
                    </p>
                    <table style={styles.table}>
                      <tbody>
                        <tr>
                          <td>
                            <hr style={styles.hr} />
                          </td>
                          <td>
                            <span style={styles.or}>OU</span>
                          </td>
                          <td>
                            <hr style={styles.hr} />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div style={styles.contentButton}>
                      <input {...getInputProps()} />
                      <button style={styles.button}>
                        <span style={styles.labelButton}>Explorer fichier</span>
                        <img
                          style={styles.iconButton}
                          src={exploreCsvIcon}
                          alt='true'
                        />
                      </button>
                    </div>
                  </div>
                </section>
              )}
            </Dropzone>
          )}
        </Mutation>
      </div>
    )
  }

  render () {
    const self = this
    return (
      <div>
        <div style={styles.container}>
          <div style={styles.header}>
            <HeaderContent title='Upload un csv' />
          </div>
          {this.state.loading ? <div style={styles.contentProgress}>
            <CircularProgress
              style={styles.progressStyle}
              color='inherit'
            />
          </div> : <div style={styles.content}>
            {self.uploadCsv()}
            <ToastContainer hideProgressBar />
          </div>
          }
        </div>
      </div>
    )
  }
}

const styles = {
  container: {
    backgroundColor: '#15191C',
    height: '100vh',
    paddingTop: '12px'
  },
  header: {
    width: '332px',
    margin: 'auto'
  },
  content: {
    backgroundColor: '#0A0A0A',
    width: '302px',
    height: '226px',
    margin: 'auto',
    paddingTop: '14px',
    border: '3px dashed #444444',
    borderRadius: '3px'
  },
  contentSection: {
    width: '242px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  iconCsv: {
    display: 'block',
    marginTop: '20px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  table: {
    marginTop: '-14px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '10px'
  },
  hr: {
    color: '#22292E',
    width: '76px'
  },
  or: {
    marginTop: '-4px',
    color: '#F2F2F2',
    fontSize: '12px',
    fontWeight: 500
  },
  label: {
    color: '#FFFFFF',
    textAlign: 'center',
    fontSize: '15px',
    fontWeight: 500
  },
  contentButton: {
    width: '180px',
    height: '32px',
    margin: 'auto'
  },
  button: {
    cursor: 'pointer',
    paddingTop: '4px',
    marginTop: '-14px',
    width: '180px',
    height: '32px',
    marginLeft: 'auto',
    marginRight: 'auto',
    borderRadius: '19px',
    borderWidth: '0px',
    backgroundColor: '#417505'
  },
  labelButton: {
    textAlign: 'center',
    color: '#FFFFFF',
    fontSize: '13px',
    fontWeight: 500
  },
  iconButton: {
    float: 'right',
    width: '26px',
    height: '26px',
    marginRight: '-4px',
    marginTop: '-4px'
  },
  modalTitle: {
    marginTop: '-10px',
    textAlign: 'center'
  },
  modalText: {
    fontSize: '12px'
  },
  buttonContent: {
    textAlign: 'center'
  },
  modalButton: {
    marginTop: '20px',
    width: '100px',
    borderWidth: '0px',
    height: '24px',
    borderRadius: '3px'
  },
  contentProgress: {
    width: '302px',
    height: '226px',
    margin: 'auto',
    paddingTop: '14px'
  },
  progressStyle: {
    marginTop: '50px',
    color: '#7ED321',
    marginLeft: '80px'
  }

}

export default UploadTicket
